import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Briefcase, Users, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import BufeteTab from "@/pages/modules/despacho/BufeteTab";
import AbogadosTab from "@/pages/modules/despacho/AbogadosTab";
import PerfilesTab from "@/pages/modules/despacho/PerfilesTab";

export default function Despacho() {
  const { user } = useAuth();
  const [tab, setTab] = useState("bufete");
  const canManageUsers = user?.role === "super_admin" || user?.role === "admin";

  return (
    <div className="space-y-8" data-testid="module-despacho">
      <div>
        <div className="text-[11px] uppercase tracking-[0.22em] text-[#C25A5A] font-semibold">Módulo</div>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl text-[#1A0810]">Despacho</h1>
        <p className="mt-2 text-sm text-[#4a3838] max-w-2xl">
          Configuración general del bufete, abogados asociados y usuarios del sistema.
        </p>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="bg-white border border-[#E5DFD3] p-1 h-auto rounded-full inline-flex">
          <TabsTrigger
            value="bufete"
            data-testid="tab-bufete"
            className="rounded-full px-5 py-2 gap-2 data-[state=active]:bg-[#7A1E2E] data-[state=active]:text-[#F1EDE4] data-[state=active]:shadow-none text-[#3d2a2a]"
          >
            <Briefcase className="h-4 w-4" strokeWidth={1.8} /> Bufete
          </TabsTrigger>
          <TabsTrigger
            value="abogados"
            data-testid="tab-abogados"
            className="rounded-full px-5 py-2 gap-2 data-[state=active]:bg-[#7A1E2E] data-[state=active]:text-[#F1EDE4] data-[state=active]:shadow-none text-[#3d2a2a]"
          >
            <Users className="h-4 w-4" strokeWidth={1.8} /> Abogados Asociados
          </TabsTrigger>
          {canManageUsers && (
            <TabsTrigger
              value="perfiles"
              data-testid="tab-perfiles"
              className="rounded-full px-5 py-2 gap-2 data-[state=active]:bg-[#7A1E2E] data-[state=active]:text-[#F1EDE4] data-[state=active]:shadow-none text-[#3d2a2a]"
            >
              <ShieldCheck className="h-4 w-4" strokeWidth={1.8} /> Perfiles
            </TabsTrigger>
          )}
        </TabsList>

        <TabsContent value="bufete" className="mt-6"><BufeteTab /></TabsContent>
        <TabsContent value="abogados" className="mt-6"><AbogadosTab /></TabsContent>
        {canManageUsers && (
          <TabsContent value="perfiles" className="mt-6"><PerfilesTab /></TabsContent>
        )}
      </Tabs>
    </div>
  );
}
